class SelectNgFilesDirective {
    constructor($sce) {
        this.restrict = 'A';
        this.$sce = $sce;
        this.scope = {
            ngModel: '='
        };
    }

    link(scope, element, attrs, ngModel) {
        element.on('change', () => {
            if (!element[0].files || element[0].files.length < 1) {
                return;
            }

            let file = element[0].files[0];

            const url = this.$sce.trustAsResourceUrl(URL.createObjectURL(file));

            if (this.ngModel) {
                URL.revokeObjectURL(this.ngModel.url);
            }

            let fileName = file.name;

            let fileType = file.type;
            if (!(fileType !== '')) {
                let fileExtensionRegex = /(?:\.([^.]+))?$/;
                let fileExtension = fileExtensionRegex.exec(file.name)[1];
                fileType = fileExtension.toLowerCase();
            }

            let fileSize = file.size;

            const form = new FormData();
            form.append('file', file, fileName);

            scope.ngModel = {'fileFormData': form, 'fileName': fileName, 'fileType': fileType, 'fileSize': fileSize, 'fileUrl': url};
            scope.$apply();
        });
    }

    static directiveFactory($sce) {
        'ngInject';
        return new SelectNgFilesDirective($sce);
    }
}

export default SelectNgFilesDirective;